export default {"src":"/_next/static/media/ai-conversation.colour.a04ebabc.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};